import { useCallback } from 'react';

import { ROUTES } from '@/common';
import { useHistory } from '@/modules/core/hooks';

import { ManageProfileTabs } from './manageProfile.types';

export const TAB_LINK = 'tab';

const useRedirectToManageProfileTab = () => {
  const history = useHistory();

  const handleOpenManageProfileTab = useCallback((tab: ManageProfileTabs) => {
    history.push(`${ROUTES.MANAGE_PROFILE}?${TAB_LINK}=${tab}`);
  }, [history]);

  return {
    handleOpenManageProfileTab,
  };
};

export default useRedirectToManageProfileTab;
